module.exports = __webpack_public_path__ + "img/icon_1.be812e27.svg";